import { BottomNavButton } from "./BottomNavButton";
import { ReactComponent as SupportIcon } from "@icons/contact-us-outline.svg";
import { ReactComponent as FilledSupportIcon } from "@icons/contact-us-filled.svg";
import { ReactComponent as FilledHealthHubIcon } from "@icons/wellbeing-filled.svg";
import { ReactComponent as FilledHomeIcon } from "@icons/home-filled.svg";
import { ReactComponent as FilledResourcesIcon } from "@icons/resources-filled.svg";
import { ReactComponent as HealthHubIcon } from "@icons/wellbeing.svg";
import { ReactComponent as HomeIcon } from "@icons/home.svg";
import { ReactComponent as ResourcesIcon } from "@icons/resources.svg";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { WisdomAINavButton } from "./WisdomAINavButton";
import { BottomNavWisdomAINotchBackground } from "./BottomNavWisdomAINotch";

export const BottomNavBar = ({ hideBottomNav }: { hideBottomNav: boolean }) => {
  const { supportLink, insetPadding } = useMobilePlatform();
  const location = useLocation();
  const path = location.pathname;

  if (hideBottomNav) {
    return null;
  }

  return (
    <>
      <div aria-hidden="true" className="h-3 shrink-0" />
      <nav
        role="navigation"
        style={{
          paddingBottom: insetPadding ? `${insetPadding.bottom}px` : undefined,
          height: insetPadding ? `${insetPadding.bottom + 80}px` : "80px",
        }}
        className="flex items-center overflow-visible w-full sticky bottom-0 z-OVERLAY mt-auto"
      >
        <BottomNavWisdomAINotchBackground />
        <div className="flex flex-col w-full mx-auto max-w-[500px] lg:max-w-[800px] sm:px-6">
          <div className={"flex flex-row justify-evenly sm:justify-between h-full w-full"}>
            <BottomNavButton
              active={path.startsWith("/home")}
              navigatePath="/home"
              activeIcon={FilledHomeIcon}
              inactiveIcon={HomeIcon}
              ariaLabel={t("navigation.homeNavigationLabel")}
              buttonText={t("navigation.homeButton")}
            />
            <BottomNavButton
              active={path.startsWith("/wellbeing")}
              navigatePath="/wellbeing"
              activeIcon={FilledHealthHubIcon}
              inactiveIcon={HealthHubIcon}
              ariaLabel={t("navigation.wellbeingNavigationLabel")}
              buttonText={t("navigation.wellbeingButton")}
            />
            <div className="w-[58px] shrink-0">
              <WisdomAINavButton className="absolute left-1/2 top-[-22px] -translate-x-1/2" />
            </div>
            <BottomNavButton
              active={path.startsWith("/resources")}
              navigatePath="/resources"
              activeIcon={FilledResourcesIcon}
              inactiveIcon={ResourcesIcon}
              ariaLabel={t("navigation.resourcesNavigationLabel")}
              buttonText={t("navigation.resourcesButton")}
            />
            <BottomNavButton
              active={path.startsWith(supportLink)}
              navigatePath={supportLink}
              activeIcon={FilledSupportIcon}
              inactiveIcon={SupportIcon}
              ariaLabel={t("navigation.supportNavigationLabel")}
              buttonText={t("navigation.supportButton")}
            />
          </div>
        </div>
      </nav>
    </>
  );
};
